import React from 'react'
import { Alert } from '../ui'
import { capitalize } from '../../helpers'

// The negotiation-state banner shown on a deal (accepted/signing/counter-offer/
// awaiting-response). Shared by carbon and ppa; the only per-app differences are
// ppa's resale-offer copy (passed via `resaleMessage`) and carbon's `pt-4`
// wrapper spacing (passed via `wrapperClass`).
export interface DealStateFields {
  status: string
  signed_flag?: boolean
  they_represent: string
  offered_to_us?: boolean
  is_resale?: boolean
}

export interface DealStateMessageProps {
  deal: DealStateFields
  // Shown when the counterparty makes a resale offer (offered_to_us && is_resale).
  // ppa power-requirement resales pass this; carbon omits it.
  resaleMessage?: string
  // Optional wrapper spacing (carbon renders the banner with pt-4; ppa bare).
  wrapperClass?: string
}

const DealStateMessage = ({ deal, resaleMessage, wrapperClass }: DealStateMessageProps) => {
  const { status, signed_flag, they_represent, offered_to_us, is_resale } = deal
  const alertProps: { message: string; type?: 'info' | 'success' | 'warning' | 'danger' } =
    status === 'accepted'
      ? (signed_flag
        ? {
          message: `You have signed the agreement. Pending ${they_represent}'s signature to ratify this deal`,
          type: 'success' as const,
        }
        : {
          message: 'Deal terms have been accepted. Please proceed to signing the agreement',
        })
      : (offered_to_us
        ? {
          message: (is_resale && resaleMessage)
            ? resaleMessage
            : `${capitalize(they_represent)} has proposed new terms. Please review and provide your response by either accepting ${they_represent}'s proposed terms or extending a counteroffer`,
        }
        : {
          message: `You have proposed new terms. Pending ${they_represent}'s response. No action is needed from your side at the moment`,
        })

  const alert = <Alert {...alertProps} />
  return wrapperClass ? <div className={wrapperClass}>{alert}</div> : alert
}

export default DealStateMessage
